const GOT_BULK_MANAGEMENT_CONFIG = 'GOT_BULK_MANAGEMENT_CONFIG';

export default GOT_BULK_MANAGEMENT_CONFIG;
